import { useContext, useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { CarritoContext } from '../context/carritoContext'
import { InputConTextoSugerencia } from '../reutilizables/inputConTextoSugerencia/InputConTextoSugerencia'
import Precios from '../reutilizables/precios/Precios'
import { obtenerPublicacion } from '../servicios/compraService'
import LinkButton from '../ui/LinkButton'
import styles from './CompraDirecta.module.css'

const CompraDirecta = () => {
  const [centroDeCostos, setCentroDeCostos] = useState(null)
  const [itemsCompra, setItemsCompra] = useState([])
  const [sugerenciasCodMat, setSugerenciasCodMat] = useState([])
  const [sugerencias, setSugerencias] = useState([])
  const [sugerenciasImputacion, setSugerenciasImputacion] = useState([])
  const { state } = useLocation()

  const { getImputacion, idPublicacionComprar, items, cantidadCompra } =
    useContext(CarritoContext)

  const cargarCentroDeCostos = async () => {
    const resp = await getImputacion()

    const opcionesImputTpos = resp.opcionesImputTpos.map((e) => ({
      value: e.tipoImpu,
      label: e.tipoImpuTextos
    }))

    const listaImputaciones = resp.listaImputaciones.map((e) => ({
      codigo: e.activoFijo || e.codigo,
      descripcion: e.descripcion,
      tipoImpu: e.tipoImpu
    }))

    setCentroDeCostos({
      ...resp,
      opcionesImputTpos,
      listaImputaciones
    })
  }

  const obtenerItems = async () => {
    if (idPublicacionComprar > 0) {
      const { data } = await obtenerPublicacion(
        parseInt(localStorage.getItem('idUsuario')),
        idPublicacionComprar
      )

      const item = data[0]
      const itemCarrito = items.find((i) => i.idPublicacion === item.idPublicacion)

      let preciosMayoristas = []
      if (item.preciosMayorista && Array.isArray(item.preciosMayorista)) {
        preciosMayoristas = item.preciosMayorista
      } else if (
        state?.detalle?.preciosMayorista &&
        Array.isArray(state.detalle.preciosMayorista)
      ) {
        preciosMayoristas = state.detalle.preciosMayorista
      } else if (
        state?.detalle?.preciosMayoristas &&
        Array.isArray(state.detalle.preciosMayoristas)
      ) {
        preciosMayoristas = state.detalle.preciosMayoristas
      } else if (item.precioUnitarioMayorista && item.cantidadMayorista) {
        preciosMayoristas = [
          {
            cantidad: item.cantidadMayorista,
            precioUnitario: item.precioUnitarioMayorista
          }
        ]
      }

      const porcDcto = Number(item.porcDcto || state?.detalle?.porcDcto) || 0
      const tieneDescuento = porcDcto > 0

      let precioBase = item.precioUnitario

      if (preciosMayoristas.length > 0) {
        const tiersValidos = preciosMayoristas
          .map((p) => ({
            ...p,
            precioUnitario: Number(p.precioUnitario ?? p.precio)
          }))
          .filter((p) => Number(p.cantidad) > 0 && Number(p.precioUnitario) > 0)
          .sort((a, b) => Number(b.cantidad) - Number(a.cantidad))
        const tramo = tiersValidos.find((p) => cantidadCompra >= Number(p.cantidad))
        if (tramo) {
          precioBase = Number(tramo.precioUnitario)
        }
      }

      setItemsCompra([
        {
          ...item,
          precioUnitario: precioBase,
          alicuota: item.alicuota ?? itemCarrito?.alicuota ?? 0,
          cantidad: cantidadCompra,
          preciosMayoristas,
          porcDcto,
          tieneDescuento
        }
      ])
    }
  }

  const esMayorista = (item) => {
    if (!item.preciosMayoristas || item.preciosMayoristas.length === 0) {
      return null
    }

    const aplicables = item.preciosMayoristas.filter(
      (mayorista) => item.cantidad >= mayorista.cantidad
    )

    if (aplicables.length === 0) {
      return null
    }

    const mejor = aplicables.reduce((prev, curr) =>
      curr.cantidad > prev.cantidad ? curr : prev
    )

    return mejor
  }

  useEffect(() => {
    if (!centroDeCostos) {
      cargarCentroDeCostos()
    }
    obtenerItems()
  }, [])

  const handleSelectSugerencias = (descripcion, propiedad, idPublicacion) => {
    modificarItem(descripcion.descripcion, propiedad, idPublicacion)
    setSugerencias([])
    setSugerenciasImputacion([])
    setSugerenciasCodMat([])
  }

  const modificarItem = (texto, propiedad) => {
    setItemsCompra((prevItems) =>
      prevItems.map((item) => ({ ...item, [propiedad]: texto }))
    )
  }

  const handleChange = (texto, propiedad, setSugerencias, array) => {
    modificarItem(texto, propiedad)
    setSugerencias(
      texto.trim() === ''
        ? []
        : array?.filter(
            (opcion) =>
              opcion.codigo?.toLowerCase().includes(texto.toLowerCase()) ||
              opcion.descripcion?.toLowerCase().includes(texto.toLowerCase())
          )
    )
  }

  return (
    <div className={`row mt-4 ml-auto mr-auto h-100 p-4 ${styles.bordePerfil}`}>
      {itemsCompra.map((item) => (
        <div className="row" key={item.idPublicacion}>
          <div className={`col-6 ${styles.textLeft}`}>
            <div>{item.titulo}</div>
            <div>(cant: {item.cantidad})</div>
            {item.porcDcto && item.porcDcto > 0 && (
              <span className={styles.badgeDescuento}>{item.porcDcto}% OFF</span>
            )}
          </div>
          <div className={`col-4 ${styles.textRight}`}>
            <Precios
              precio={item.precioUnitario}
              monedaSimbolo={item.monedaSimbolo}
              alicuota={item.alicuota}
              cantidad={item.cantidad}
              showSinIVA={true}
              sufijo={esMayorista(item) ? '(mayorista)' : ''}
              mostrarDescuento={Boolean(item.tieneDescuento)}
              porcDcto={item.porcDcto}
              className={styles.precioBox}
            />
          </div>
          <div
            className={`d-flex flex-wrap align-items-center ${styles.marginLeft} mb-2 ${styles.gapBloque2}`}
          >
            <InputConTextoSugerencia
              styles={styles}
              texto={'Código de material'}
              codigo={`codMat-${item.codigo}`}
              value={item.codMat || ''}
              setSugerencias={setSugerenciasCodMat}
              arrayChance={centroDeCostos?.catalogoMateriales}
              sugerencias={sugerenciasCodMat}
              categoria={'codMat'}
              handleSelectSugerencias={handleSelectSugerencias}
              handleChange={handleChange}
              idPublicacion={item.idPublicacion}
            />
            <InputConTextoSugerencia
              texto={'Planta'}
              codigo={`inputPlanta-${item.codigo}`}
              value={item.valorPlanta || ''}
              setSugerencias={setSugerencias}
              arrayChance={centroDeCostos?.usuariosPlantaEfectiva}
              sugerencias={sugerencias}
              categoria={'valorPlanta'}
              handleSelectSugerencias={handleSelectSugerencias}
              handleChange={handleChange}
              idPublicacion={item.idPublicacion}
            />
            <InputConTextoSugerencia
              texto={'Imputación'}
              codigo={`imputacion-${item.codigo}`}
              value={item.imputacionTipo || ''}
              arrayChance={centroDeCostos?.opcionesImputTpos}
              categoria={'imputacionTipo'}
              modificarCarrito={modificarItem}
              idPublicacion={item.idPublicacion}
            />
            {item.imputacionTipo && (
              <InputConTextoSugerencia
                texto={
                  centroDeCostos?.opcionesImputTpos?.find(
                    (opcion) => opcion.value === item.imputacionTipo
                  )?.label
                }
                codigo={`inputPlanta-${item.codigo}`}
                value={item.imputacionTipoOpcion || ''}
                setSugerencias={setSugerenciasImputacion}
                arrayChance={centroDeCostos?.listaImputaciones?.filter(
                  (opcion) => opcion.tipoImpu === item.imputacionTipo
                )}
                sugerencias={sugerenciasImputacion}
                categoria={'imputacionTipoOpcion'}
                handleSelectSugerencias={handleSelectSugerencias}
                handleChange={handleChange}
                idPublicacion={item.idPublicacion}
              />
            )}
          </div>
        </div>
      ))}
      {itemsCompra.length > 0 && (
        <LinkButton
          className="btn btn-primary btn-comprar w-25 "
          to={{
            pathname: '/Compras',
            state: {
              imputacion: {
                codMat: itemsCompra[0].codMat,
                valorPlanta: itemsCompra[0].valorPlanta,
                imputacionTipo: itemsCompra[0].imputacionTipo,
                imputacionTipoOpcion: itemsCompra[0].imputacionTipoOpcion
              },
              tieneDescuento: itemsCompra[0].tieneDescuento,
              porcDcto: itemsCompra[0].porcDcto,
              esMayorista: esMayorista({
                ...itemsCompra[0],
                preciosMayoristas: state?.detalle?.preciosMayorista
              }),
              detalle: {
                preciosMayoristas:
                  itemsCompra[0].preciosMayoristas ||
                  state?.detalle?.preciosMayorista ||
                  []
              },
              preciosMayorista:
                itemsCompra[0].preciosMayoristas || state?.detalle?.preciosMayorista || []
            }
          }}
        >
          Comprar Ahora
        </LinkButton>
      )}
    </div>
  )
}

export default CompraDirecta
